import _classCallCheck from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import Input from './input';
var EVENT_TYPE = 'contextmenu';

var ContextmenuInput = /*#__PURE__*/function (_Input) {
  _inherits(ContextmenuInput, _Input);

  var _super = _createSuper(ContextmenuInput);

  function ContextmenuInput(element, callback, options) {
    var _this;

    _classCallCheck(this, ContextmenuInput);

    _this = _super.call(this, element, callback, options);

    _this.handleEvent = function (event) {
      if (!_this.options.enable) {
        return;
      }

      _this.callback({
        type: EVENT_TYPE,
        center: {
          x: event.clientX,
          y: event.clientY
        },
        srcEvent: event,
        pointerType: 'mouse',
        target: event.target
      });
    };

    element.addEventListener('contextmenu', _this.handleEvent);
    return _this;
  }

  _createClass(ContextmenuInput, [{
    key: "destroy",
    value: function destroy() {
      this.element.removeEventListener('contextmenu', this.handleEvent);
    }
    /**
     * Enable this input (begin processing events)
     * if the specified event type is among those handled by this input.
     */

  }, {
    key: "enableEventType",
    value: function enableEventType(eventType, enabled) {
      if (eventType === EVENT_TYPE) {
        this.options.enable = enabled;
      }
    }
  }]);

  return ContextmenuInput;
}(Input);

export { ContextmenuInput as default };